import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-mb-3 p-d-flex p-jc-end" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Buscador", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Roles", -1)
const _hoisted_5 = { class: "p-multiselect-representative-option" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "English Academy", -1)
const _hoisted_7 = { class: "p-mb-3 p-d-flex p-ai-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "p-ml-2" }, "Si", -1)
const _hoisted_9 = { class: "p-mb-1 p-d-flex p-ai-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "p-ml-2" }, "No", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Mes de alta", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Mes de expiración", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Estados", -1)
const _hoisted_14 = { class: "p-multiselect-representative-option" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        onClick: _ctx.downloadNewEnrollmenContractsReport,
        type: "button",
        class: "p-button-success",
        icon: "pi pi-file-excel",
        label: "Descargar reporte"
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_DataTable, {
      responsiveLayout: "scroll",
      filterDisplay: "menu",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters = $event)),
      onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event))),
      onFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFilter($event))),
      lazy: true,
      paginator: true,
      rows: _ctx.params.limit,
      rowsPerPageOptions: [20,50,100],
      totalRecords: _ctx.totalRecords,
      value: _ctx.contracts,
      loading: _ctx.loading,
      globalFilterFields: ['userName', 'createdAt', 'expirationDate', 'status', 'roles', 'groups']
    }, {
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          filterField: "userName",
          header: "Nombre",
          style: {"min-width":"14rem"},
          filterMenuStyle: {'width':'18rem'},
          showFilterMatchModes: false,
          showFilterOperator: false,
          showAddButton: false
        }, {
          body: _withCtx(({ data: { firstName, lastName } }) => [
            _createTextVNode(_toDisplayString(firstName) + " " + _toDisplayString(lastName), 1)
          ]),
          filter: _withCtx(({filterModel}) => [
            _hoisted_3,
            _createVNode(_component_InputText, {
              type: "text",
              minlength: 3,
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter",
              placeholder: "Buscar por nombre y apellido"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Rol",
          style: {"min-width":"14rem"},
          filterField: "roles",
          showFilterOperator: false,
          filterMenuStyle: {'width':'14rem'},
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          body: _withCtx(({
        data: {
          role,
        },
      }) => [
            _createTextVNode(_toDisplayString(_ctx.contractRole(role)), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_4,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.roleFilterOptions,
              optionValue: "value",
              optionLabel: "name",
              placeholder: "Rol",
              class: "p-column-filter"
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "EnglishAcademy",
          style: {"min-width":"14rem"},
          filterField: "groups",
          showFilterOperator: false,
          filterMenuStyle: {'width':'14rem'},
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          body: _withCtx(({
        data: {
          group,
        },
      }) => [
            _createTextVNode(_toDisplayString(_ctx.contractGroup(group)), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Checkbox, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                value: "EnglishAcademy"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Checkbox, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                value: "Regular"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _hoisted_10
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Alta",
          style: {"min-width":"14rem"},
          filterField: "createdAt",
          showFilterOperator: false,
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          body: _withCtx(({
          data: {
            createdAt,
          },
        }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(createdAt, _ctx.FormatDates.LatinAmerica)), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_11,
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              view: "month",
              dateFormat: "mm/yy",
              placeholder: "mm/yyyy"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Fin del contrato",
          filterField: "expirationDate",
          style: {"min-width":"14rem"},
          showFilterOperator: false,
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          body: _withCtx(({ data: { expirationDate } }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(expirationDate, _ctx.FormatDates.LatinAmerica)), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_12,
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              view: "month",
              dateFormat: "mm/yy",
              placeholder: "mm/yyyy"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          "filter-field": "status",
          header: "Estado del contrato",
          style: {"min-width":"14rem"},
          showFilterOperator: false,
          filterMenuStyle: {'width':'14rem'},
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          body: _withCtx(({ data: { status } }) => [
            _createElementVNode("span", {
              style: _normalizeStyle({
          color: _ctx.contractStatusTextColor(status),
          fontWeight: 700,
        })
            }, _toDisplayString(_ctx.contractStatus(status)), 5)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _hoisted_13,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusFilterOptions,
              optionValue: "value",
              optionLabel: "name",
              placeholder: "Estado",
              class: "p-column-filter"
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({
            color: _ctx.contractStatusTextColor(slotProps.option.value),
            fontWeight: 700,
          })
                  }, _toDisplayString(_ctx.contractStatus(slotProps.option.value)), 5)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              onClick: (e) => _ctx.toggleActionsMenu(e, data),
              "aria-controls": "contract-action-menu",
              "aria-haspopup": "true",
              class: "p-button-text",
              icon: "pi pi-ellipsis-h",
              type: "button"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Menu, {
              key: data.id,
              id: "contract-action-menu",
              ref: "actionMenu",
              model: _ctx.actionMenuItems,
              popup: true
            }, null, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filters", "rows", "totalRecords", "value", "loading"])
  ], 64))
}